import { Divider, Skeleton, Stack } from '@mantine/core';
import type { Incident } from '../../../api';
import { CommentStoreProvider } from '../../../components/Comment';
import { ErrorBoundary } from '../../../components/ErrorBoundary';
import IncidentActivity from '../../MonitorPage/v2/IncidentDrawer/IncidentActivity';
import IncidentDownstreamResources from '../../MonitorPage/v2/IncidentDrawer/IncidentDownstreamResources';
import IncidentMeasurementChart from '../../MonitorPage/v2/IncidentDrawer/IncidentMeasurmentChart';

interface V2IncidentContentProps {
	incident?: Incident;
}

function V2IncidentContent({ incident }: V2IncidentContentProps) {
	const emptyFallback = () => <></>;

	return (
		<Stack>
			{!incident && <Skeleton h={400} />}
			{incident && <IncidentMeasurementChart incident={incident} />}
			{incident?.target && <Divider />}
			{incident?.target && (
				<ErrorBoundary fallback={emptyFallback}>
					<IncidentDownstreamResources incident={incident} />
				</ErrorBoundary>
			)}
			<Divider />
			<CommentStoreProvider>
				{incident && (
					<ErrorBoundary fallback={emptyFallback}>
						<IncidentActivity incident={incident} />
					</ErrorBoundary>
				)}
			</CommentStoreProvider>
		</Stack>
	);
}

export default V2IncidentContent;
